// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { messages, pagerOf, pagerPage, pagerTotalPages } from '../messages/main';
import { provideIntlService, provideLocalizationService } from '@progress/kendo-vue-intl';
/**
 * @hidden
 */

var PagerInputVue2 = {
  name: 'KendoPagerInput',
  props: {
    totalPages: Number,
    currentPage: Number,
    messagesMap: Function
  },
  inject: {
    kendoIntlService: {
      default: null
    },
    kendoLocalizationService: {
      default: null
    }
  },
  created: function created() {
    this._text = undefined;
  },
  methods: {
    changeHangler: function changeHangler(e) {
      var text = this._text = e.target.value.replace(/\D/g, '');
      this.$forceUpdate();

      if (text) {
        this.$emit('pagechange', parseInt(text, 10), e);
      }
    },
    blurHandler: function blurHandler() {
      this.$forceUpdate();
    },
    value: function value() {
      var value = this._text === undefined ? this.$props.currentPage.toString() : this._text;
      this._text = undefined;
      return value;
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    var kendoIntlService = inject('kendoIntlService', {});
    var kendoLocalizationService = inject('kendoLocalizationService', {});
    return {
      v3: v3,
      kendoIntlService: kendoIntlService,
      kendoLocalizationService: kendoLocalizationService
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var intlService = provideIntlService(this);
    var localizationService = provideLocalizationService(this);
    var pageMessage = this.$props.messagesMap ? this.$props.messagesMap(pagerPage) : {
      messageKey: pagerPage,
      defaultMessage: messages[pagerPage]
    };
    var ofMessage = this.$props.messagesMap ? this.$props.messagesMap(pagerOf) : {
      messageKey: pagerOf,
      defaultMessage: messages[pagerOf]
    };
    var totalPagesMessage = this.$props.messagesMap ? this.$props.messagesMap(pagerTotalPages) : {
      messageKey: pagerTotalPages,
      defaultMessage: messages[pagerTotalPages]
    };
    return h("span", {
      "class": "k-pager-input k-label"
    }, [localizationService.toLanguageString(pageMessage.messageKey, pageMessage.defaultMessage), h("span", {
      "class": "k-textbox k-input k-input-md k-rounded-md k-input-solid"
    }, [h("input", {
      "class": "k-input-inner",
      value: this.v3 ? this.value() : null,
      domProps: this.v3 ? undefined : {
        "value": this.value()
      },
      onBlur: this.blurHandler,
      on: this.v3 ? undefined : {
        "blur": this.blurHandler,
        "change": this.changeHangler
      },
      onChange: this.changeHangler
    })]), " ", "".concat(localizationService.toLanguageString(ofMessage.messageKey, ofMessage.defaultMessage), " ").concat(intlService.format(localizationService.toLanguageString(totalPagesMessage.messageKey, totalPagesMessage.defaultMessage), [this.$props.totalPages]))]);
  }
};
/**
 * @hidden
 */

var PagerInput = PagerInputVue2;
export { PagerInput, PagerInputVue2 };